import { HQ_SERVICE } from "app_constants";
import { auth0Origin } from "interfaces/auth0";

function logout() {
  const origin = auth0Origin();
  const logoutReturnRoute = encodeURIComponent(`${HQ_SERVICE}/auth0/logout`);

  window.location.href = `${origin}/v2/logout?returnTo=${logoutReturnRoute}`;
}

export { logout };
